export default [
  {
    path: '/chat',
    name: 'chat',
    component: () => import('@/views/chat/Chat.vue'),
    meta: {
      resource: 'chat',
      action: 'read',
      title: 'breadcrumb.chat',
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
    },
  },
]
